import { authFetchGET, authFetchPOST } from '../utils/auth-fetch';

const env = (<any>window).appenv.services.portmemos;

export interface PilotInfo
{
    terminalCode: string;
    timeToPilotInSeconds: number|null;
    timeToBerthInSeconds: number|null;
}

export class PortMemosService {
    static serviceAvailable(): boolean {
        return !!env;
    }

    static async getTerminalPortMemo(terminalId: string) {
        const portMemoUIDs = await authFetchGET(env.scope, `${env.baseurl}/v1/portmemos/terminals/${terminalId}`);
        let res = [];
        for (let portMemoUID of portMemoUIDs) {
            res.push(await authFetchGET(env.scope, `${env.baseurl}/v1/portmemos/${portMemoUID}`));
        }
        return res;
    }
}
